import React from 'react'
import Images from '../assets/AllImages';

const OUTDOOR = () => {
  return (

    <>
      <main>
        <div className="container-fluid bg-primary py-3 py-md-0">
          <div className="row  align-items-center">
            <div className="col-12 col-md-6 px-5">
              <h5 className='text-white fw-bold my-0'>OUTDOOR</h5>
            </div>

            <div className="col-12 col-md-6 px-5 d-none d-sm-block">
              <img src={Images.Vactor2} alt="" className='w-50 float-end' />
            </div>
          </div>
        </div>
      </main>

      {/* create a banner section */}

      <div className="container-fluid outdoor-banner text-md-center text-white mb-5 mb-sm-0 px-0">
        <div className="col-md-8 px-4 px-md-5">
          <h3 className='fw-bold py-3'>Outdoor Olympic Pool & Kids Pool</h3>
          <p className='fw-bold'>A World-Class Aquatic Experience Under the Open Sky</p>
          <p className='fs-6'>Step Arena’s Outdoor Olympic Pool is one of the most advanced open-air aquatic facilities in the region, offering elite-level infrastructure for swimmers, clubs, families, and international events. Nestled in nature and surrounded by fresh air, it’s designed to meet the highest standards of performance, safety, and comfort.</p>
        </div>
      </div>


      {/* Create a specification Section */}

      <div className="container-fluid mb-5 mb-sm-0">
        <div className="row">

          <div className="col-md-6 px-sm-5 px-4 d-flex flex-column justify-content-center">
            <h4 className='text-primary fw-bold'>Kids’ Pool – Safe, Fun, and Supervised</h4>
            <p>Created for the youngest visitors, our Children’s Pool is perfect for early swimming lessons, recreational play, and building water confidence.</p>
            <ul className='text-primary fw-bold'>
              <li>Dimensions: 15 meters in length</li>
              <li>Depth: 85 cm – ideal for ages 3 to 6</li>
              <li>Safety: Lifeguard supervision and child-safe design elements</li>
            </ul>
            <p>This pool provides a joyful and secure environment for children to enjoy the water while being closely monitored by our trained staff.</p>
          </div>

          <div className="col-md-6 px-0">
            <img src={Images.SwimmingCenter1} alt="" className='w-100' />
          </div>
        </div>
      </div>

      <div className="container-fluid mb-5 mb-sm-0">
        <div className="row">
          <div className="col-md-6 px-0 mb-5 mb-sm-0">
            <img src={Images.SwimmingCenter2} alt="" className='w-100' />
          </div>

          <div className="col-md-6 px-sm-5 px-4 d-flex flex-column justify-content-center">
            <h4 className='text-primary fw-bold'>Kids’ Pool – Safe, Fun, and Supervised</h4>
            <p>Created for the youngest visitors, our Children’s Pool is perfect for early swimming lessons, recreational play, and building water confidence.</p>
            <ul className='text-primary fw-bold'>
              <li>Dimensions: 15 meters in length</li>
              <li>Depth: 85 cm – ideal for ages 3 to 6</li>
              <li>Safety: Lifeguard supervision and child-safe design elements</li>
            </ul>
            <p>This pool provides a joyful and secure environment for children to enjoy the water while being closely monitored by our trained staff.</p>
          </div>
        </div>
      </div>

      <div className="container-fluid mb-5 mb-sm-0">
        <div className="row">

          <div className="col-md-6 px-sm-5 px-4 d-flex flex-column justify-content-center">
            <h4 className='text-primary fw-bold'>Kids’ Pool – Safe, Fun, and Supervised</h4>
            <p>Created for the youngest visitors, our Children’s Pool is perfect for early swimming lessons, recreational play, and building water confidence.</p>
            <ul className='text-primary fw-bold'>
              <li>Dimensions: 15 meters in length</li>
              <li>Depth: 85 cm – ideal for ages 3 to 6</li>
              <li>Safety: Lifeguard supervision and child-safe design elements</li>
            </ul>
            <p>This pool provides a joyful and secure environment for children to enjoy the water while being closely monitored by our trained staff.</p>
          </div>

          <div className="col-md-6 px-0">
            <img src={Images.GymWeight} alt="" className='w-100' />
          </div>
        </div>
      </div>

    </>
  )
}

export default OUTDOOR;
